const MAJOR_CITIES = [
  // USA - Major Cities
  { name: 'New York', fullName: 'New York, NY', iata: 'NYC' },
  { name: 'Los Angeles', fullName: 'Los Angeles, CA', iata: 'LAX' },
  { name: 'Chicago', fullName: 'Chicago, IL', iata: 'ORD' },
  { name: 'Miami', fullName: 'Miami, FL', iata: 'MIA' },
  { name: 'Dallas', fullName: 'Dallas, TX', iata: 'DFW' },
  { name: 'Houston', fullName: 'Houston, TX', iata: 'IAH' },
  { name: 'Phoenix', fullName: 'Phoenix, AZ', iata: 'PHX' },
  { name: 'Philadelphia', fullName: 'Philadelphia, PA', iata: 'PHL' },
  { name: 'San Francisco', fullName: 'San Francisco, CA', iata: 'SFO' },
  { name: 'Atlanta', fullName: 'Atlanta, GA', iata: 'ATL' },
  { name: 'Las Vegas', fullName: 'Las Vegas, NV', iata: 'LAS' },
  { name: 'Seattle', fullName: 'Seattle, WA', iata: 'SEA' },
  { name: 'Denver', fullName: 'Denver, CO', iata: 'DEN' },
  { name: 'Detroit', fullName: 'Detroit, MI', iata: 'DTW' },
  { name: 'Boston', fullName: 'Boston, MA', iata: 'BOS' },
  { name: 'Minneapolis', fullName: 'Minneapolis, MN', iata: 'MSP' },
  { name: 'Orlando', fullName: 'Orlando, FL', iata: 'MCO' },
  { name: 'Washington', fullName: 'Washington, DC', iata: 'IAD' },
  
  // USA - Additional Major Markets
  { name: 'Tampa', fullName: 'Tampa, FL', iata: 'TPA' },
  { name: 'Baltimore', fullName: 'Baltimore, MD', iata: 'BWI' },
  { name: 'San Diego', fullName: 'San Diego, CA', iata: 'SAN' },
  { name: 'St. Louis', fullName: 'St. Louis, MO', iata: 'STL' },
  { name: 'Nashville', fullName: 'Nashville, TN', iata: 'BNA' },
  { name: 'Portland', fullName: 'Portland, OR', iata: 'PDX' },
  { name: 'Sacramento', fullName: 'Sacramento, CA', iata: 'SMF' },
  { name: 'San Jose', fullName: 'San Jose, CA', iata: 'SJC' },
  { name: 'San Antonio', fullName: 'San Antonio, TX', iata: 'SAT' },
  { name: 'Salt Lake City', fullName: 'Salt Lake City, UT', iata: 'SLC' },
  { name: 'Columbus', fullName: 'Columbus, OH', iata: 'CMH' },
  { name: 'Charlotte', fullName: 'Charlotte, NC', iata: 'CLT' },
  { name: 'Indianapolis', fullName: 'Indianapolis, IN', iata: 'IND' },
  { name: 'Milwaukee', fullName: 'Milwaukee, WI', iata: 'MKE' },
  { name: 'Cleveland', fullName: 'Cleveland, OH', iata: 'CLE' },
  { name: 'Austin', fullName: 'Austin, TX', iata: 'AUS' },
  { name: 'Cincinnati', fullName: 'Cincinnati, OH', iata: 'CVG' },
  { name: 'Kansas City', fullName: 'Kansas City, MO', iata: 'MCI' },
  { name: 'Oakland', fullName: 'Oakland, CA', iata: 'OAK' },
  { name: 'Pittsburgh', fullName: 'Pittsburgh, PA', iata: 'PIT' },
  { name: 'New Orleans', fullName: 'New Orleans, LA', iata: 'MSY' },
  { name: 'Buffalo', fullName: 'Buffalo, NY', iata: 'BUF' },
  
  // USA - Additional Cities
  { name: 'Raleigh', fullName: 'Raleigh, NC', iata: 'RDU' },
  { name: 'Memphis', fullName: 'Memphis, TN', iata: 'MEM' },
  { name: 'Richmond', fullName: 'Richmond, VA', iata: 'RIC' },
  { name: 'Louisville', fullName: 'Louisville, KY', iata: 'SDF' },
  { name: 'Oklahoma City', fullName: 'Oklahoma City, OK', iata: 'OKC' },
  { name: 'Providence', fullName: 'Providence, RI', iata: 'PVD' },
  { name: 'Jacksonville', fullName: 'Jacksonville, FL', iata: 'JAX' },
  { name: 'Fort Lauderdale', fullName: 'Fort Lauderdale, FL', iata: 'FLL' },
  { name: 'Hartford', fullName: 'Hartford, CT', iata: 'BDL' },
  { name: 'El Paso', fullName: 'El Paso, TX', iata: 'ELP' },
  { name: 'Albuquerque', fullName: 'Albuquerque, NM', iata: 'ABQ' },
  { name: 'Birmingham', fullName: 'Birmingham, AL', iata: 'BHM' },
  { name: 'Boise', fullName: 'Boise, ID', iata: 'BOI' },
  { name: 'Little Rock', fullName: 'Little Rock, AR', iata: 'LIT' },
  { name: 'Charleston', fullName: 'Charleston, SC', iata: 'CHS' },
  { name: 'Tucson', fullName: 'Tucson, AZ', iata: 'TUS' },
  { name: 'Omaha', fullName: 'Omaha, NE', iata: 'OMA' },
  { name: 'Tulsa', fullName: 'Tulsa, OK', iata: 'TUL' },
  { name: 'Des Moines', fullName: 'Des Moines, IA', iata: 'DSM' },
  { name: 'Spokane', fullName: 'Spokane, WA', iata: 'GEG' },
  { name: 'Madison', fullName: 'Madison, WI', iata: 'MSN' },
  { name: 'Palm Springs', fullName: 'Palm Springs, CA', iata: 'PSP' },
  { name: 'Syracuse', fullName: 'Syracuse, NY', iata: 'SYR' },
  { name: 'Colorado Springs', fullName: 'Colorado Springs, CO', iata: 'COS' },
  
  // Canada - Major Cities
  { name: 'Toronto', fullName: 'Toronto, ON', iata: 'YYZ' },
  { name: 'Vancouver', fullName: 'Vancouver, BC', iata: 'YVR' },
  { name: 'Montreal', fullName: 'Montreal, QC', iata: 'YUL' },
  { name: 'Calgary', fullName: 'Calgary, AB', iata: 'YYC' },
  { name: 'Edmonton', fullName: 'Edmonton, AB', iata: 'YEG' },
  { name: 'Ottawa', fullName: 'Ottawa, ON', iata: 'YOW' },
  { name: 'Winnipeg', fullName: 'Winnipeg, MB', iata: 'YWG' },
  
  // Canada - Additional Cities
  { name: 'Quebec City', fullName: 'Quebec City, QC', iata: 'YQB' },
  { name: 'Halifax', fullName: 'Halifax, NS', iata: 'YHZ' },
  { name: 'St. John\'s', fullName: 'St. John\'s, NL', iata: 'YYT' },
  { name: 'Regina', fullName: 'Regina, SK', iata: 'YQR' },
  { name: 'Saskatoon', fullName: 'Saskatoon, SK', iata: 'YXE' },
  { name: 'Victoria', fullName: 'Victoria, BC', iata: 'YYJ' },
  { name: 'London', fullName: 'London, ON', iata: 'YXU' },
  
  // Mexico - Major Cities
  { name: 'Mexico City', fullName: 'Mexico City, MX', iata: 'MEX' },
  { name: 'Cancun', fullName: 'Cancun, MX', iata: 'CUN' },
  { name: 'Guadalajara', fullName: 'Guadalajara, MX', iata: 'GDL' },
  { name: 'Monterrey', fullName: 'Monterrey, MX', iata: 'MTY' },
  
  // Mexico - Additional Cities
  { name: 'Tijuana', fullName: 'Tijuana, MX', iata: 'TIJ' },
  { name: 'Puerto Vallarta', fullName: 'Puerto Vallarta, MX', iata: 'PVR' },
  { name: 'Los Cabos', fullName: 'Los Cabos, MX', iata: 'SJD' },
  { name: 'Merida', fullName: 'Merida, MX', iata: 'MID' },
  { name: 'Leon', fullName: 'Leon, MX', iata: 'BJX' },
  { name: 'Queretaro', fullName: 'Queretaro, MX', iata: 'QRO' },
  { name: 'Oaxaca', fullName: 'Oaxaca, MX', iata: 'OAX' }
];

export default MAJOR_CITIES; 